<div class="tem-field" [formGroup]="group">
    <label class="tem-field-label">{{config.COLUMNDESC}}</label>
    <div class="tem-field-row">
        <nz-select [attr.tabindex]="tabindex" [formControlName]="config.COLUMNNAME" #select (ngModelChange)="dynaServices.editingEventHandle($event);editing()" (nzBlur)="bluring({ type: 'blur' })">
            <nz-option *ngFor="let tipo of contentSelect" [nzValue]="tipo.value" [nzLabel]="tipo.view"></nz-option>
        </nz-select>
        <button nz-button nzType="text" nzSize="small" *ngIf="toolTipText!=null" [tooltip]="toolTipText">
            <nz-icon nzType="question-circle"></nz-icon>
        </button>
        <form-field-properties [information]="config" [entityDesc]="entityDesc" [entityName]="entityName" *ngIf="canConfig" [row]="row"></form-field-properties>
    </div>
</div>
